export default __webpack_public_path__ + "static/media/switch.f00287d8.svg";